import { render, staticRenderFns } from "./SuggestedVideos.vue?vue&type=template&id=2288226c&scoped=true&"
import script from "./SuggestedVideos.vue?vue&type=script&lang=js&"
export * from "./SuggestedVideos.vue?vue&type=script&lang=js&"
import style0 from "./SuggestedVideos.vue?vue&type=style&index=0&id=2288226c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2288226c",
  null
  
)

/* custom blocks */
import block0 from "./SuggestedVideos.vue?vue&type=custom&index=0&blockType=translations"
if (typeof block0 === 'function') block0(component)

export default component.exports